/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_SubtitleInputs */

const en_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch your own AI-powered storefront. Sell digital products, physical goods, and services, all in one place, with your own brand.`)
};

const es_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanza tu propia tienda impulsada por IA. Vende productos digitales, bienes físicos y servicios, todo en un solo lugar, con tu propia marca.`)
};

const fr_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez votre propre vitrine propulsée par l'IA. Vendez des produits numériques, des biens physiques et des services — le tout au même endroit, avec votre propre marque.`)
};

const de_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte deine eigene KI-gestützte Storefront. Verkaufe digitale Produkte, physische Waren und Dienstleistungen — alles an einem Ort, unter deiner eigenen Marke.`)
};

const ja_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIを活用した独自のストアフロントを立ち上げましょう。デジタル製品、物理的な商品、サービスを、すべて一箇所でご自身のブランドで販売できます。`)
};

const zh_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动您自己的 AI 驱动店铺。销售数字产品、实体商品和服务——全在一个地方，打造您自己的品牌。`)
};

const ar_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أطلق واجهة متجرك الخاصة المدعومة بالذكاء الاصطناعي. بِع المنتجات الرقمية والسلع المادية والخدمات — كلها في مكان واحد، بعلامتك التجارية الخاصة.`)
};

const id_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luncurkan etalase berbasis AI Anda sendiri. Jual produk digital, barang fisik, dan layanan — semua dalam satu tempat, dengan merek Anda sendiri.`)
};

const it_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancia la tua vetrina basata sull'IA. Vendi prodotti digitali, beni fisici e servizi — tutto in un unico posto, con il tuo brand.`)
};

const ru_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запустите свою собственную витрину на базе ИИ. Продавайте цифровые продукты, физические товары и услуги — все в одном месте, под собственным брендом.`)
};

const pt_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lance sua própria vitrine com inteligência artificial. Venda produtos digitais, bens físicos e serviços — tudo em um só lugar, com a sua própria marca.`)
};

const ko_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나만의 AI 기반 스토어프론트를 런칭하세요. 디지털 제품, 실물 상품, 서비스를 한 곳에서 나만의 브랜드로 판매하세요.`)
};

/**
* | output |
* | --- |
* | "Launch your own AI-powered storefront. Sell digital products, physical goods, and services, all in one place, with your own brand." |
*
* @param {Home_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_hero_subtitle = /** @type {((inputs?: Home_Hero_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_subtitle(inputs)
	if (locale === "es") return es_home_hero_subtitle(inputs)
	if (locale === "fr") return fr_home_hero_subtitle(inputs)
	if (locale === "de") return de_home_hero_subtitle(inputs)
	if (locale === "ja") return ja_home_hero_subtitle(inputs)
	if (locale === "zh") return zh_home_hero_subtitle(inputs)
	if (locale === "ar") return ar_home_hero_subtitle(inputs)
	if (locale === "id") return id_home_hero_subtitle(inputs)
	if (locale === "it") return it_home_hero_subtitle(inputs)
	if (locale === "ru") return ru_home_hero_subtitle(inputs)
	if (locale === "pt") return pt_home_hero_subtitle(inputs)
	return ko_home_hero_subtitle(inputs)
});